export default (() => ({
	init() {
		const focusableElements = this.$el.querySelectorAll('a[href], button:not([disabled])');
		const firstFocusableElement = focusableElements[0];
		const lastFocusableElement = focusableElements[focusableElements.length - 1];
		this.$el.addEventListener('keydown', (e) => {
			if(!this.$store.global.mobileMenuOpen) {
				return;
			}
			const isTabPressed = e.key === 'Tab' || e.keyCode === 9;
			if (!isTabPressed) {
				return;
			}
			if (e.shiftKey) {
				if (document.activeElement === firstFocusableElement) {
					lastFocusableElement.focus();
					e.preventDefault();
				}
			} else {
				if (document.activeElement === lastFocusableElement) {
					firstFocusableElement.focus();
					e.preventDefault();
				}
			}
		});
	},
}))